import { useEffect, useRef } from "react"
import Sortable from "sortablejs"

const useSortable = (onReorder, options = {}) => {
  const containerRef = useRef(null)
  const sortableRef = useRef(null)
  const onReorderRef = useRef(onReorder)
  onReorderRef.current = onReorder

  useEffect(() => {
    if (!containerRef.current) return

    sortableRef.current = new Sortable(containerRef.current, {
      handle: ".sortable-handle",
      animation: 150,
      dragClass: "sortable--current",
      ghostClass: "sortable--ghost",
      ...options,
      onStart: (e) => {
        // Snapshot DOM order before SortableJS mutates it
        e.from._savedOrder = [...e.from.children]
      },
      onEnd: (e) => {
        // Restore DOM order — let React handle the actual reorder
        const saved = e.from._savedOrder
        if (saved) {
          saved.forEach(child => e.from.appendChild(child))
          delete e.from._savedOrder
        }

        const from = e.oldDraggableIndex != null ? e.oldDraggableIndex : e.oldIndex
        const to = e.newDraggableIndex != null ? e.newDraggableIndex : e.newIndex
        if (from !== to) onReorderRef.current(from, to)
      },
    })

    return () => {
      if (sortableRef.current) {
        sortableRef.current.destroy()
        sortableRef.current = null
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return containerRef
}

export default useSortable
